import moment = require("moment");
import { INewsItem, NewsService } from "../../../services";

class NewsItemBasicController {
    private newsItem: INewsItem;
    private newsItemTypes: any[];

    constructor(
        private NewsService: NewsService,
        private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService,
        private SweetAlert: any
    ) {
        'ngInject';
    }

    public $onInit = () => {
        this.newsItemTypes = [
            {
                id: 2,
                name: 'Intern'
            },
            {
                id: 4,
                name: 'Klant'
            },
            {
                id: 1,
                name: 'Medewerker'
            },
        ];

        if (this.$stateParams['id']) {
            this.get();
        }
    }

    get() {
        this.NewsService.get(this.$stateParams['id']).then(res => {
            this.newsItem = res;
        })
    }

    public save = () => {
        this.newsItem.createdDate = moment(this.newsItem.createdDate).format('YYYY-MM-DD') + ' 00:00:00';
        this.newsItem.expireDate = moment(this.newsItem.expireDate).format('YYYY-MM-DD') + ' 23:59:59';
        if (this.newsItem.id != undefined) {
            this.NewsService.put(this.newsItem.id, this.newsItem).then((res) => {
                this.closeModal();
            });
        } else {
            this.NewsService.post(this.newsItem).then((res) => {
                this.closeModal();
            });
        }
    }

    public delete = () => {
        this.SweetAlert.swal({
            title: 'Weet je het zeker?',
            text: "Je verwijdert het nieuws item '"+ this.newsItem.title +"'. Dit kan niet meer ongedaan gemaakt worden!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Verwijderen',
            cancelButtonText: 'Annuleren',
        }, (isConfirm) => {
            if (isConfirm) {
                this.NewsService.delete(this.newsItem.id).then(() => {
                    this.closeModal();
                });
            } else {

            }
        });
    }

    private closeModal() {
        this.$state.go('^', {}, { reload: true });
    }
}

export const newsItemBasicComponent = { 
    bindings: {
        close: "&"
    },
    controller: NewsItemBasicController,
    template: require('./news.item.basic.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/news/news.item.basic.component.ts